import { ClassType, EntityStatusBadgeVariant } from '@frontend/common';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export enum PackageStateName {
    PACKAGE_CREATED = 'package_created',
    PACKAGE_DROP_OFF_PENDING = 'package_drop_off_pending',
    PACKAGE_DROP_OFF_SKIPPED = 'package_drop_off_skipped',
    PACKAGE_DROP_OFF_STARTED = 'package_drop_off_started',
    PACKAGE_DROP_OFF_DONE = 'package_drop_off_done',
    PACKAGE_DROP_OFF_CANCELLED = 'package_drop_off_cancelled',
    PACKAGE_DROP_OFF_FAILED = 'package_drop_off_failed',
    PACKAGE_PICK_UP_PENDING = 'package_pick_up_pending',
    PACKAGE_PICK_UP_SKIPPED = 'package_pick_up_skipped',
    PACKAGE_PICK_UP_STARTED = 'package_pick_up_started',
    PACKAGE_PICK_UP_DONE = 'package_pick_up_done',
    PACKAGE_PICK_UP_CANCELLED = 'package_pick_up_cancelled',
    PACKAGE_PICK_UP_FAILED = 'package_pick_up_failed',
    PACKAGE_PASS_THROUGH_PENDING = 'package_pass_through_pending',
    PACKAGE_PASS_THROUGH_STARTED = 'package_pass_through_started',
    PACKAGE_PASS_THROUGH_DONE = 'package_pass_through_done',
    PACKAGE_PASS_THROUGH_CANCELLED = 'package_pass_through_cancelled',
    PACKAGE_PASS_THROUGH_FAILED = 'package_pass_through_failed',
    PACKAGE_AUDIT_PENDING = 'package_audit_pending',
    PACKAGE_AUDIT_STARTED = 'package_audit_started',
    PACKAGE_AUDIT_DONE = 'package_audit_done',
    PACKAGE_AUDIT_CANCELLED = 'package_audit_cancelled',
    PACKAGE_AUDIT_FAILED = 'package_audit_failed',
    PACKAGE_REMOVAL_PENDING = 'package_removal_pending',
    PACKAGE_REMOVAL_STARTED = 'package_removal_started',
    PACKAGE_REMOVAL_DONE = 'package_removal_done',
    PACKAGE_REMOVAL_CANCELLED = 'package_removal_cancelled',
    PACKAGE_REMOVAL_FAILED = 'package_removal_failed'
}

export class PackageState {
    static readonly PACKAGE_CREATED = new PackageState(
        PackageStateName.PACKAGE_CREATED,
        (
            <FormattedMessage
                id='packageState.created'
                description='package state created'
                defaultMessage='Created'
            />
        )
    );
    static readonly PACKAGE_DROP_OFF_PENDING = new PackageState(
        PackageStateName.PACKAGE_DROP_OFF_PENDING,
        (
            <FormattedMessage
                id='packageState.dropoff_pending'
                description='package state dropoff pending'
                defaultMessage='Drop-off pending'
            />
        )
    );
    static readonly PACKAGE_DROP_OFF_SKIPPED = new PackageState(
        PackageStateName.PACKAGE_DROP_OFF_SKIPPED,
        (
            <FormattedMessage
                id='packageState.dropoff_skipped'
                description='package state dropoff skipped'
                defaultMessage='Drop-off skipped'
            />
        )
    );
    static readonly PACKAGE_DROP_OFF_STARTED = new PackageState(
        PackageStateName.PACKAGE_DROP_OFF_STARTED,
        (
            <FormattedMessage
                id='packageState.dropoff_started'
                description='package state dropoff started'
                defaultMessage='Drop-off started'
            />
        )
    );
    static readonly PACKAGE_DROP_OFF_DONE = new PackageState(
        PackageStateName.PACKAGE_DROP_OFF_DONE,
        (
            <FormattedMessage
                id='packageState.dropoff_done'
                description='package state dropoff done'
                defaultMessage='Drop-off done'
            />
        )
    );
    static readonly PACKAGE_DROP_OFF_CANCELLED = new PackageState(
        PackageStateName.PACKAGE_DROP_OFF_CANCELLED,
        (
            <FormattedMessage
                id='packageState.dropoff_cancelled'
                description='package state dropoff cancelled'
                defaultMessage='Drop-off cancelled'
            />
        )
    );
    static readonly PACKAGE_DROP_OFF_FAILED = new PackageState(
        PackageStateName.PACKAGE_DROP_OFF_FAILED,
        (
            <FormattedMessage
                id='packageState.dropoff_failed'
                description='package state dropoff failed'
                defaultMessage='Drop-off failed'
            />
        )
    );
    static readonly PACKAGE_PICK_UP_PENDING = new PackageState(
        PackageStateName.PACKAGE_PICK_UP_PENDING,
        (
            <FormattedMessage
                id='packageState.pickup_pending'
                description='package state pickup pending'
                defaultMessage='Pick-up pending'
            />
        )
    );
    static readonly PACKAGE_PICK_UP_SKIPPED = new PackageState(
        PackageStateName.PACKAGE_PICK_UP_SKIPPED,
        (
            <FormattedMessage
                id='packageState.pickup_skipped'
                description='package state pickup skipped'
                defaultMessage='Pick-up skipped'
            />
        )
    );
    static readonly PACKAGE_PICK_UP_STARTED = new PackageState(
        PackageStateName.PACKAGE_PICK_UP_STARTED,
        (
            <FormattedMessage
                id='packageState.pickup_started'
                description='package state pickup started'
                defaultMessage='Pick-up started'
            />
        )
    );
    static readonly PACKAGE_PICK_UP_DONE = new PackageState(
        PackageStateName.PACKAGE_PICK_UP_DONE,
        (
            <FormattedMessage
                id='packageState.pickup_done'
                description='package state pickup done'
                defaultMessage='Pick-up done'
            />
        )
    );
    static readonly PACKAGE_PICK_UP_CANCELLED = new PackageState(
        PackageStateName.PACKAGE_PICK_UP_CANCELLED,
        (
            <FormattedMessage
                id='packageState.pickup_cancelled'
                description='package state pickup cancelled'
                defaultMessage='Pick-up cancelled'
            />
        )
    );
    static readonly PACKAGE_PICK_UP_FAILED = new PackageState(
        PackageStateName.PACKAGE_PICK_UP_FAILED,
        (
            <FormattedMessage
                id='packageState.pickup_failed'
                description='package state pickup failed'
                defaultMessage='Pick-up failed'
            />
        )
    );
    static readonly PACKAGE_PASS_THROUGH_STARTED = new PackageState(
        PackageStateName.PACKAGE_PASS_THROUGH_STARTED,
        (
            <FormattedMessage
                id='packageState.pass_through_started'
                description='package state pass through started (panorama doorgeefluik)'
                defaultMessage='Pass Through started'
            />
        )
    );
    static readonly PACKAGE_PASS_THROUGH_DONE = new PackageState(
        PackageStateName.PACKAGE_PASS_THROUGH_DONE,
        (
            <FormattedMessage
                id='packageState.pass_through_done'
                description='package state pass through done (panorama doorgeefluik)'
                defaultMessage='Pass Through done'
            />
        )
    );
    static readonly PACKAGE_PASS_THROUGH_PENDING = new PackageState(
        PackageStateName.PACKAGE_PASS_THROUGH_PENDING,
        (
            <FormattedMessage
                id='packageState.pass_through_pending'
                description='package state pass through pending (panorama doorgeefluik)'
                defaultMessage='Pass Through pending'
            />
        )
    );
    static readonly PACKAGE_PASS_THROUGH_CANCELLED = new PackageState(
        PackageStateName.PACKAGE_PASS_THROUGH_CANCELLED,
        (
            <FormattedMessage
                id='packageState.pass_through_cancelled'
                description='package state pass through cancelled'
                defaultMessage='Pass Through cancelled'
            />
        )
    );
    static readonly PACKAGE_PASS_THROUGH_FAILED = new PackageState(
        PackageStateName.PACKAGE_PASS_THROUGH_FAILED,
        (
            <FormattedMessage
                id='packageState.pass_through_failed'
                description='package state pass through failed'
                defaultMessage='Pass Through failed'
            />
        )
    );
    static readonly PACKAGE_AUDIT_PENDING = new PackageState(
        PackageStateName.PACKAGE_AUDIT_PENDING,
        (
            <FormattedMessage
                id='packageState.audit_pending'
                description='package state audit pending'
                defaultMessage='Audit pending'
            />
        )
    );
    static readonly PACKAGE_AUDIT_STARTED = new PackageState(
        PackageStateName.PACKAGE_AUDIT_STARTED,
        (
            <FormattedMessage
                id='packageState.audit_started'
                description='package state audit started'
                defaultMessage='Audit started'
            />
        )
    );
    static readonly PACKAGE_AUDIT_DONE = new PackageState(
        PackageStateName.PACKAGE_AUDIT_DONE,
        (
            <FormattedMessage
                id='packageState.audit_done'
                description='package state audit done'
                defaultMessage='Audit done'
            />
        )
    );
    static readonly PACKAGE_AUDIT_CANCELLED = new PackageState(
        PackageStateName.PACKAGE_AUDIT_CANCELLED,
        (
            <FormattedMessage
                id='packageState.audit_cancelled'
                description='package state audit cancelled'
                defaultMessage='Audit cancelled'
            />
        )
    );
    static readonly PACKAGE_AUDIT_FAILED = new PackageState(
        PackageStateName.PACKAGE_AUDIT_FAILED,
        (
            <FormattedMessage
                id='packageState.audit_failed'
                description='package state audit failed'
                defaultMessage='Audit failed'
            />
        )
    );
    static readonly PACKAGE_REMOVAL_PENDING = new PackageState(
        PackageStateName.PACKAGE_REMOVAL_PENDING,
        (
            <FormattedMessage
                id='packageState.removal_pending'
                description='package state removal pending'
                defaultMessage='Removal pending'
            />
        )
    );
    static readonly PACKAGE_REMOVAL_STARTED = new PackageState(
        PackageStateName.PACKAGE_REMOVAL_STARTED,
        (
            <FormattedMessage
                id='packageState.removal_started'
                description='package state removal started'
                defaultMessage='Removal started'
            />
        )
    );
    static readonly PACKAGE_REMOVAL_DONE = new PackageState(
        PackageStateName.PACKAGE_REMOVAL_DONE,
        (
            <FormattedMessage
                id='packageState.removal_done'
                description='package state removal done'
                defaultMessage='Removal done'
            />
        )
    );
    static readonly PACKAGE_REMOVAL_CANCELLED = new PackageState(
        PackageStateName.PACKAGE_REMOVAL_CANCELLED,
        (
            <FormattedMessage
                id='packageState.removal_cancelled'
                description='package state removal cancelled'
                defaultMessage='Removal cancelled'
            />
        )
    );
    static readonly PACKAGE_REMOVAL_FAILED = new PackageState(
        PackageStateName.PACKAGE_REMOVAL_FAILED,
        (
            <FormattedMessage
                id='packageState.removal_failed'
                description='package state removal failed'
                defaultMessage='Removal failed'
            />
        )
    );

    static readonly ALL = [
        PackageState.PACKAGE_CREATED,
        PackageState.PACKAGE_DROP_OFF_PENDING,
        PackageState.PACKAGE_DROP_OFF_SKIPPED,
        PackageState.PACKAGE_DROP_OFF_STARTED,
        PackageState.PACKAGE_DROP_OFF_DONE,
        PackageState.PACKAGE_DROP_OFF_CANCELLED,
        PackageState.PACKAGE_DROP_OFF_FAILED,
        PackageState.PACKAGE_PICK_UP_PENDING,
        PackageState.PACKAGE_PICK_UP_SKIPPED,
        PackageState.PACKAGE_PICK_UP_STARTED,
        PackageState.PACKAGE_PICK_UP_DONE,
        PackageState.PACKAGE_PICK_UP_CANCELLED,
        PackageState.PACKAGE_PICK_UP_FAILED,
        PackageState.PACKAGE_PASS_THROUGH_PENDING,
        PackageState.PACKAGE_PASS_THROUGH_STARTED,
        PackageState.PACKAGE_PASS_THROUGH_DONE,
        PackageState.PACKAGE_PASS_THROUGH_CANCELLED,
        PackageState.PACKAGE_PASS_THROUGH_FAILED,
        PackageState.PACKAGE_AUDIT_PENDING,
        PackageState.PACKAGE_AUDIT_STARTED,
        PackageState.PACKAGE_AUDIT_DONE,
        PackageState.PACKAGE_AUDIT_CANCELLED,
        PackageState.PACKAGE_AUDIT_FAILED,
        PackageState.PACKAGE_REMOVAL_PENDING,
        PackageState.PACKAGE_REMOVAL_STARTED,
        PackageState.PACKAGE_REMOVAL_DONE,
        PackageState.PACKAGE_REMOVAL_CANCELLED,
        PackageState.PACKAGE_REMOVAL_FAILED
    ];

    constructor(
        public value: PackageStateName,
        public displayName: React.ReactNode
    ) {}

    static getByValue(action: PackageStateName): PackageState | undefined {
        return this.ALL.find((a) => a.value == action);
    }

    static getType(action: PackageStateName): ClassType {
        switch (action) {
            case PackageStateName.PACKAGE_DROP_OFF_STARTED:
            case PackageStateName.PACKAGE_PICK_UP_STARTED:
            case PackageStateName.PACKAGE_PASS_THROUGH_STARTED:
            case PackageStateName.PACKAGE_AUDIT_STARTED:
            case PackageStateName.PACKAGE_REMOVAL_STARTED:
                return ClassType.WARNING;
            case PackageStateName.PACKAGE_PICK_UP_PENDING:
            case PackageStateName.PACKAGE_DROP_OFF_PENDING:
            case PackageStateName.PACKAGE_PASS_THROUGH_PENDING:
            case PackageStateName.PACKAGE_AUDIT_PENDING:
            case PackageStateName.PACKAGE_REMOVAL_PENDING:
            case PackageStateName.PACKAGE_DROP_OFF_SKIPPED:
            case PackageStateName.PACKAGE_PICK_UP_SKIPPED:
                return ClassType.SECONDARY;
            case PackageStateName.PACKAGE_DROP_OFF_DONE:
            case PackageStateName.PACKAGE_PICK_UP_DONE:
            case PackageStateName.PACKAGE_PASS_THROUGH_DONE:
            case PackageStateName.PACKAGE_AUDIT_DONE:
            case PackageStateName.PACKAGE_REMOVAL_DONE:
                return ClassType.SUCCESS;
            case PackageStateName.PACKAGE_CREATED:
                return ClassType.INFO;
            case PackageStateName.PACKAGE_DROP_OFF_CANCELLED:
            case PackageStateName.PACKAGE_PICK_UP_CANCELLED:
            case PackageStateName.PACKAGE_PASS_THROUGH_CANCELLED:
            case PackageStateName.PACKAGE_AUDIT_CANCELLED:
            case PackageStateName.PACKAGE_REMOVAL_CANCELLED:
            case PackageStateName.PACKAGE_DROP_OFF_FAILED:
            case PackageStateName.PACKAGE_PICK_UP_FAILED:
            case PackageStateName.PACKAGE_PASS_THROUGH_FAILED:
            case PackageStateName.PACKAGE_AUDIT_FAILED:
            case PackageStateName.PACKAGE_REMOVAL_FAILED:
            default:
                return ClassType.DANGER;
        }
    }

    static getBadgeVariant(state: PackageStateName): EntityStatusBadgeVariant {
        switch (state) {
            case PackageStateName.PACKAGE_CREATED:
            case PackageStateName.PACKAGE_DROP_OFF_STARTED:
            case PackageStateName.PACKAGE_PICK_UP_STARTED:
            case PackageStateName.PACKAGE_PASS_THROUGH_STARTED:
            case PackageStateName.PACKAGE_AUDIT_STARTED:
            case PackageStateName.PACKAGE_REMOVAL_STARTED:
                return EntityStatusBadgeVariant.Draft;
            case PackageStateName.PACKAGE_DROP_OFF_PENDING:
            case PackageStateName.PACKAGE_DROP_OFF_DONE:
                return EntityStatusBadgeVariant.AwaitingDropOff;
            case PackageStateName.PACKAGE_PICK_UP_PENDING:
            case PackageStateName.PACKAGE_PICK_UP_DONE:
            case PackageStateName.PACKAGE_PASS_THROUGH_PENDING:
            case PackageStateName.PACKAGE_AUDIT_PENDING:
            case PackageStateName.PACKAGE_REMOVAL_PENDING:
                return EntityStatusBadgeVariant.AwaitingPickUp;
            case PackageStateName.PACKAGE_PASS_THROUGH_DONE:
            case PackageStateName.PACKAGE_AUDIT_DONE:
            case PackageStateName.PACKAGE_REMOVAL_DONE:
                return EntityStatusBadgeVariant.Completed;
            case PackageStateName.PACKAGE_DROP_OFF_CANCELLED:
            case PackageStateName.PACKAGE_PICK_UP_CANCELLED:
            case PackageStateName.PACKAGE_PASS_THROUGH_CANCELLED:
            case PackageStateName.PACKAGE_AUDIT_CANCELLED:
            case PackageStateName.PACKAGE_REMOVAL_CANCELLED:
            case PackageStateName.PACKAGE_DROP_OFF_SKIPPED:
            case PackageStateName.PACKAGE_PICK_UP_SKIPPED:
                return EntityStatusBadgeVariant.Cancelled;
            case PackageStateName.PACKAGE_DROP_OFF_FAILED:
            case PackageStateName.PACKAGE_PICK_UP_FAILED:
            case PackageStateName.PACKAGE_PASS_THROUGH_FAILED:
            case PackageStateName.PACKAGE_AUDIT_FAILED:
            case PackageStateName.PACKAGE_REMOVAL_FAILED:
                return EntityStatusBadgeVariant.Failed;
            default:
                return EntityStatusBadgeVariant.Cancelled;
        }
    }
}
